export default __webpack_public_path__ + "static/media/battery.f8336f21.jpg";